import { useState, useRef } from "react";

//scss
import "./style.scss";

//assets
import { SvgButtonArrowLeft } from "assets/icons/js/SvgButtonArrowLeft";
import { SvgButtonArrowRight } from "assets/icons/js/SvgButtonArrowRight";

//custom hooks
import { useMediaQuery } from "customHooks/useMediaQuery";
import useCheckEndsReached from "customHooks/useCheckEndsReached";

//helpers
import getImg from "helpers/getCloudinaryImage";

//components
import Gallery from "../GalleryCarouselPopup";

const Spotlights = ({ data, theme = {} }) => {
	const width = useMediaQuery();
	const breakpoint = 900;

	// only works for "SS test villa do not book"
	const listingID = window.location.pathname.split("/")[2].split("-")[5];

	//check reaching ends of the list
	const listRef = useRef(null);
	const { reachedRight, reachedLeft } = useCheckEndsReached({ ref: listRef });

	//gallery carousel stuff
	const [openGallery, setOpenGallery] = useState(false);
	const [clickedImageIndex, setClickedImageIndex] = useState(null);
	const openGalleryAndSetIndex = (index) => {
		setOpenGallery(true);
		setClickedImageIndex(index);
	};

	const spotlights = parseSpotlightsData(data);
	if (spotlights.length === 0) return null;

	const linksForIframe = {
		0: "https://momento360.com/e/u/ae6599f34acd4302b80e3dc290dd6b0b?utm_campaign=embed&utm_source=other&heading=118.07&pitch=-6.65&field-of-view=75&size=medium&autoplay-annotations=true//d3mglmf7pb1ghj.cloudfront.net/uploads/1656044573_zw4yycri6cuy5r86gp6v_full.jpg",
		1: "https://momento360.com/e/u/cd4714d9266f443ba82979049a273f7a?utm_campaign=embed&utm_source=other&heading=343.51&pitch=13.15&field-of-view=47.5&size=medium",
		2: "https://momento360.com/e/u/f3b25f7e29564e5987cae41e6d2a2793?utm_campaign=embed&utm_source=other&heading=0&pitch=0&field-of-view=91&size=medium",
	};

	return (
		<section
			className={`listing__spotlights ${
				theme?.name === "xseries" && "xseries-spotlight"
			}`}
		>
			<Gallery
				imageText={spotlights}
				open={openGallery}
				setOpen={setOpenGallery}
				clickedImageIndex={clickedImageIndex}
				type={"spotlights"}
			/>
			<h2>
				{/* {width > breakpoint && ( */}
				<div className="listing__spotlight-arrows">
					<span
						className="button-one"
						onClick={() => (listRef.current.scrollLeft += -595)}
					>
						{reachedLeft ? (
							<SvgButtonArrowLeft
								rectFill={theme?.background}
								rectStroke={theme?.textButtonColor}
								pathFill={theme?.textButtonColor}
							/>
						) : (
							<SvgButtonArrowRight
								rectFill={theme?.background}
								rectStroke={theme?.textButtonColor}
								pathFill={theme?.textButtonColor}
								style={{ transform: "rotate(180deg)" }}
							/>
						)}
					</span>
					<span
						className="button-two"
						onClick={() => (listRef.current.scrollLeft += 590)}
					>
						{reachedRight ? (
							<SvgButtonArrowLeft
								rectFill={theme?.background}
								rectStroke={theme?.textButtonColor}
								pathFill={theme?.textButtonColor}
								style={{ transform: "rotate(180deg)" }}
							/>
						) : (
							<SvgButtonArrowRight
								rectFill={theme?.background}
								rectStroke={theme?.textButtonColor}
								pathFill={theme?.textButtonColor}
							/>
						)}
					</span>
				</div>
				{/* )} */}
			</h2>
			<div className="listing__spotlight-cards" ref={listRef}>
				{spotlights.map(({ image, description }, index) => {
					const src = getImg({
						id: image.ImgId,
						version: image.version,
						quality: "60",
						width: "580",
						height: "270",
					});

					if (listingID === "FufadJjriDVXSmKG") {
						return (
							<div className="listing__spotlight-card" key={index}>
								<iframe
									title={`360 view of listing ${index}`}
									height="250px"
									width="95%"
									allowFullScreen={true}
									src={linksForIframe[index]}
								></iframe>
								<div className="description text-xsm clr-black">
									{description}
								</div>
							</div>
						);
					} else {
						return (
							<div
								className="listing__spotlight-card"
								key={index}
								onClick={() => openGalleryAndSetIndex(index)}
							>
								<img src={src} alt={description} loading="lazy" />
								<div
									className="description text-xsm"
									style={{ color: theme?.primaryTextColor }}
								>
									{description}
								</div>
							</div>
						);
					}
				})}
			</div>
		</section>
	);
};

export default Spotlights;

const parseIdAndVersion = (str) => {
	let img = {};
	[img.version, img.ImgId] = str
		?.slice(str.indexOf("uploads/") + 8, str.indexOf("_full"))
		?.split("_");
	return img;
};

const parseSpotlightsData = (data) => {
	if (!data) return [];
	let spotlights = [];
	data.forEach(({ caption, image }) => {
		const img = parseIdAndVersion(image.IMAGE_URL_FULL);
		spotlights.push({
			image: img,
			description: caption,
			url: `https://ik.imagekit.io/5tgxhsqev/saffronstays-media/tr:w-1500,h-1000${img.ImgId}`,
		});
	});
	return spotlights;
};
